import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import messages from './ArticleContent.intl';
import styles from './ArticleContent.module.scss';

@injectIntl
export default class ArticleContent extends Component {
  static propTypes = {
    article: PropTypes.object.isRequired,
    rodoClause: PropTypes.string.isRequired
  };

  static defaultProps = {
    className: ''
  };

  render() {
    const {
      jobType,
      // salary,
      shortDescription,
      dutiesLabel,
      duties,
      requiredSkillsLabel,
      requiredSkills,
      offerDetailsLabel,
      offerDetails
    } = this.props.article;

    const isHTML = text => {
      const regex = /(<([^>]+)>)/;
      return regex.test(text);
    };
    return (
      <article
        className={`${styles.ArticleContentComponent} ${
          styles.ComponentMargin
        }`}
      >
        {jobType && (
          <p>
            {this.props.intl.formatMessage(messages.employmentType)} {jobType}
          </p>
        )}
        {/* {salary && <p>{this.props.intl.formatMessage(messages.salary)} {salary}</p>} */}
        {shortDescription && (
          <>
            <h3>{this.props.intl.formatMessage(messages.offerDescription)}</h3>
            {isHTML(shortDescription) ? (
              <div
                dangerouslySetInnerHTML={{ __html: shortDescription }}
                className={styles.description}
              />
            ) : (
              <p className={styles.description}>{shortDescription}</p>
            )}
          </>
        )}
        {dutiesLabel &&
          duties && (
            <>
              <h3>{dutiesLabel}</h3>
              <div dangerouslySetInnerHTML={{ __html: duties }} />
            </>
          )}
        {requiredSkillsLabel &&
          requiredSkills && (
            <>
              <h3>{requiredSkillsLabel}</h3>
              <div dangerouslySetInnerHTML={{ __html: requiredSkills }} />
            </>
          )}
        {offerDetailsLabel &&
          offerDetails && (
            <>
              <h3>{offerDetailsLabel}</h3>
              <div dangerouslySetInnerHTML={{ __html: offerDetails }} />
            </>
          )}
        <footer>
          <h3>{this.props.intl.formatMessage(messages.joinUs)}</h3>
        </footer>
      </article>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/JobOfferArticle/components/Article/ArticleContent/ArticleContent.js